@if(chat())
{
<div class="chat">
    <div class="chat-open-btn"  [class.dimmed]="dimmed" (click)="onChat()">
        <mat-icon>chat</mat-icon>
    </div>
    <openai-chatkit class="chatkit open-target" [class.open]="visible"
     [style.--open-height]="height"
     [style.--open-width]="width" #chatkit>
    </openai-chatkit>
</div>
}
